/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

// IntroBlock.js
import React from 'react';
import './IntroBlock.css';


export default function IntroBlock({ lang, onOpenModal  }) {
  const content = {
    fr: {
      title: "Rejoins le creuset de l’innovation",
      questions: [
        "Tu es un innovateur ?",
        "Tu es un investisseur prêt à soutenir des projets d’avenir ?",
        "Tu proposes des services qui favorisent la réussite ?"
      ],
      mission: "🔗 Notre mission : vous connecter pour transformer vos idées en progrès.",
      cta: "→ Découvrir l’initiative"
    },
    en: {
      title: "Join the Land Of Innovation",
      questions: [
        "Are you an innovator?",
        "Are you an investor ready to support the future?",
        "Do you offer services that promote success?"
      ],
      mission: "Our mission: connecting people to transform ideas into collective progress.",
      cta: "→ Discover the initiative"
    }
  };

  const t = content[lang];

  return (
    <div className="intro-block">
      <h1>{t.title}</h1>
      <div className="questions">
        {t.questions.map((q, i) => (
          <p key={i}>{q}</p>
        ))}
      </div>
      <p className="mission">{t.mission}</p>
      <button className="cta" onClick={onOpenModal}>{t.cta}</button>
    </div>
  );
}
